// Threshold (in seconds) below which a rack's pending deletion is surfaced in the
// UI — 1209600s = ~14 days. Used by the racks list, racks table, and rack details
// to decide when to show the inactivity-deletion banner / "marked for deletion" status.
export const DISPLAY_TIME_TO_DELETION_DURATION = 1209600;
